import { api } from './client';
import type { Envelope } from './types';
import type { MeetingStatus } from './meetings';

export interface RoomSummary {
  id: string;
  name: string;
  description: string | null;
  ownerUserId: string;
  memberCount: number;
  meetingCount: number;
  createdAt: string;
}

export interface RoomMember {
  userId: string;
  nickname: string;
  joinedAt: string;
}

export interface RoomDetail {
  id: string;
  name: string;
  description: string | null;
  ownerUserId: string;
  members: RoomMember[];
  createdAt: string;
}

export interface RoomMeeting {
  id: string;
  title: string;
  region: string | null;
  status: MeetingStatus;
  confirmedDate: string | null;
  createdAt: string;
}

export async function createRoom(input: {
  name: string;
  description?: string;
  fromMeetingId?: string;
}) {
  const { data } = await api.post<Envelope<RoomSummary>>('/rooms', input);
  return data.data;
}

export async function listRooms() {
  const { data } = await api.get<Envelope<RoomSummary[]>>('/rooms');
  return Array.isArray(data.data) ? data.data : [];
}

export async function getRoom(roomId: string) {
  const { data } = await api.get<Envelope<RoomDetail>>(`/rooms/${roomId}`);
  return data.data;
}

export async function listRoomMeetings(roomId: string) {
  const { data } = await api.get<Envelope<RoomMeeting[]>>(`/rooms/${roomId}/meetings`);
  return Array.isArray(data.data) ? data.data : [];
}

export async function createRoomMeeting(
  roomId: string,
  input: { title: string; region?: string; memo?: string },
) {
  const { data } = await api.post<Envelope<RoomMeeting>>(`/rooms/${roomId}/meetings`, input);
  return data.data;
}
